import moment from "moment";
import CashViewGrid from "./CashRegisterGrid";
import {Card} from "antd";
import CashViewFilter from "./CashViewFilter";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import {DataGridProvider} from "../../core/components/data-grid/DataGridContext";
import {useUser} from "../../core/context/UserContext";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";

export default function CashViewApp()
{
    const {user} = useUser();

    useEffect(() => {
        document.title = `${t('Cash Register')} - ${AppConfig.getHisTitle()}`
    }, []);

    return (
        <SimpleLayout fullWidth={true}>
            <Card title={t('Cash Register')}>
                <DataGridProvider
                    defaultFilter={{
                        startDate: moment(),
                        endDate: moment(),
                        cashRegisterId: user?.userCashRegisters?.find(x => x.isDefault)?.cashRegisterId
                    }}
                >
                    <CashViewFilter />
                    <CashViewGrid />
                </DataGridProvider>
            </Card>
        </SimpleLayout>
    )
}